import { successSvg } from './svg';
import intlTelInput from 'intl-tel-input';
import Gender from '../../app/enums/Gender';
import capitalize from 'lodash-es/capitalize';
import HttpMethod from '../../app/enums/HttpMethod';
import Practitioner from '../../app/models/Practitioner';
import CalendarEvent from '../../app/models/CalendarEvent';
import Establishment from '../../app/models/Establishment';
import { isEmail, redirect } from '../../app/support/utils';
import AppointmentType from '../../app/enums/AppointmentType';
import { isAuthenticated } from '../../app/support/functions';
import AppointmentRequest from '../../app/models/AppointmentRequest';
import { currentLocaleIs, failHandler, initIntlInput, intlInstance, localizedRoute, toast, __, __t, __v } from '../../app/support/helpers';

class Wizard {

    /**
     * @type {Wizard}
     */
    private static _instance: Wizard;

    /**
     * @type {number}
     */
    private currentStep: number;

    /**
     * @type {number}
     */
    private totalSteps: number;

    /**
     * @type {HTMLElement}
     */
    private smsCounter: number;

    /**
     * @type {Practitioner}
     */
    private practitioner: Practitioner;

    /**
     * @type {Establishment}
     */
     private establishment: Establishment;

    /**
     * @type {CalendarEvent}
     */
    private calendarEvent: CalendarEvent;

    /**
     * @type {HTMLSelectElement}
     */
    private motiveElement: HTMLSelectElement;

    /**
     * @type {JQuery}
     */
    private $motiveElement: JQuery;

    /**
     * @type {HTMLSelectElement}
     */
    private typeElement: HTMLSelectElement;

    /**
     * @type {JQuery}
     */
    private $typeElement: JQuery;

    /**
     * @type {HTMLTextAreaElement}
     */
    private infoElement: HTMLTextAreaElement;

    /**
     * @type {HTMLInputElement}
     */
    private isFormerVisitorElement: HTMLInputElement;

    /**
     * @type {HTMLInputElement}
     */
    private firstnameElement: HTMLInputElement;

    /**
     * @type {HTMLInputElement}
     */
    private lastnameElement: HTMLInputElement;

    /**
     * @type {HTMLSelectElement}
     */
    private genderElement: HTMLSelectElement;

    /**
     * @type {string}
     */
     private mobile: string;

    /**
     * @type {HTMLInputElement}
     */
    private mobileElement: HTMLInputElement;

    /**
     * @type {intlTelInput.Plugin}
     */
    private mobileInstance: intlTelInput.Plugin;

    /**
     * @type {HTMLInputElement}
     */
    private emailElement: HTMLInputElement;

    /**
     * @type {HTMLInputElement}
     */
    private birthdateElement: HTMLInputElement;

    /**
     * @type {HTMLInputElement}
     */
    private termsElement: HTMLInputElement;

    /**
     * @type {HTMLInputElement}
     */
     private privacyElement: HTMLInputElement;

    /**
     * @type {HTMLInputElement}
     */
    private verificationCodeElement: HTMLInputElement;

    /**
     * @type {HTMLButtonElement}
     */
    private resendVerificationCodeButton: HTMLButtonElement;

    /**
     * @type {HTMLButtonElement[]}
     */
    private forwardButtons: HTMLButtonElement[];

    /**
     * @type {HTMLButtonElement[]}
     */
    private backwardButtons: HTMLButtonElement[];

    /**
     * @type {HTMLElement}
     */
    private stepsProgressElement: HTMLElement;

    /**
     * @type {HTMLElement}
     */
    private loaderElement: HTMLElement;

    /**
     * @type {HTMLElement}
     */
    private focusedElement: HTMLElement;

    /**
     * Constructor
     */
    constructor () {

        if (Wizard._instance) {
            return Wizard._instance;
        }

        Wizard._instance = this;

        this.currentStep             = 2;
        this.totalSteps              = 4;
        this.smsCounter              = 0;
        this.motiveElement           = document.querySelector('select[name=motive]');
        this.$motiveElement          = $(this.motiveElement);
        this.typeElement             = document.querySelector('select[name=type]');
        this.$typeElement            = $(this.typeElement);
        this.infoElement             = document.querySelector('textarea[name=info]');
        this.isFormerVisitorElement  = document.querySelector('input[name=is_former_visitor]');
        this.stepsProgressElement    = document.querySelector('.stepsProgress');
        this.firstnameElement        = document.querySelector('input[name=firstname]');
        this.lastnameElement         = document.querySelector('input[name=lastname]');
        this.genderElement           = document.querySelector('select[name=gender]');
        this.mobileElement           = document.querySelector('input[name=mobile]');
        initIntlInput(this.mobileElement);
        this.mobileInstance          = intlInstance(this.mobileElement);
        this.emailElement            = document.querySelector('input[name=email]');
        this.birthdateElement        = document.querySelector('input[name=birthdate]');
        this.termsElement            = document.querySelector('input[name=terms]');
        this.privacyElement          = document.querySelector('input[name=privacy]');
        this.verificationCodeElement = document.querySelector('input[name=verification_code]');
        this.resendVerificationCodeButton = document.querySelector('.resendVerificationCode');
        this.forwardButtons          = Array.from(document.querySelectorAll('button.forward'));
        this.backwardButtons         = Array.from(document.querySelectorAll('button.backward'));
        this.calendarEvent           = CalendarEvent.new(window.doctori.calendarEvent as {});
        this.practitioner            = Practitioner.new(window.doctori.practitioner as {});
        this.establishment           = Establishment.new(window.doctori.establishment as {});
        this.loaderElement           = document.querySelector('.bar-loader');

        this.verificationCodeChangeHandler = this.verificationCodeChangeHandler.bind(this);
        this.addVerificationCodeChangeListener();

        this.resendVerificationCodeClickHandler = this.resendVerificationCodeClickHandler.bind(this);
        this.addResendVerificationCodeClickListener();
    }

    /**
     * Add submit event listener to the form
     *
     * @returns {void}
     */
    addVerificationCodeChangeListener(): void {
        this.verificationCodeElement.addEventListener('input', this.verificationCodeChangeHandler);
    }

    /**
     * Submit 'confim delete modal' form handler
     *
     * @param {Event} e
     * @returns {void}
     */
    verificationCodeChangeHandler(e?: Event): void {
        e.preventDefault();
        if (this.getVerificationCode()) {
            this.verificationCodeElement.classList.remove('is-invalid');
        } else {
            this.verificationCodeElement.classList.add('is-invalid');
        }
    }

    /**
     * Add submit event listener to the form
     *
     * @returns {void}
     */
    addResendVerificationCodeClickListener(): void {
        this.resendVerificationCodeButton.addEventListener('click', this.resendVerificationCodeClickHandler);
    }

    /**
     * Submit 'confim delete modal' form handler
     *
     * @param {Event} e
     * @returns {void}
     */
    resendVerificationCodeClickHandler(e?: Event): void {
        e.preventDefault();
        this.sendVerificationCode();
    }

    /**
     * Forward
     *
     * @returns {Wizard}
     */
    forward(): Wizard {
        if (this.readyToSubmit()) {
            this.submitForm();
            return this;
        }

        if (!this.currentStepIsValid()) {
            this.scrollToTop();
            return this;
        };

        this.whenItsTimeSendVerificationCode();
        this.incrementCurrentStep();
        this.navigate();
        return this;
    }

    /**
     * Backward
     *
     * @returns {Wizard}
     */
    backward(): Wizard {
        this.decrementCurrentStep();
        this.navigate();
        return this;
    }

    /**
     * Check if current step is valid
     *
     * @returns {boolean}
     */
    currentStepIsValid(): boolean {
        switch (this.currentStep) {
            case 1:
                return this.firstStepIsValid();
                break;
            case 2:
                return this.secondStepIsValid();
                break;
            case 3:
                return true;
                break;
            case 4:
                return this.fourthStepIsValid();
                break;
            default:
                return false;
                break;
        }
    }

     /**
     * Validate first step
     *
     * @returns {boolean}
     */
    firstStepIsValid(): boolean {
        if (! this.getMotiveId()) {
            this.motiveElement.parentElement.classList.add('is-invalid');
            toast(__v('required', 'motive')).error();
            this.focusedElement = this.motiveElement;
            return false;
        }

        this.motiveElement.parentElement.classList.remove('is-invalid');

        if (! this.validTypes().includes(this.getType())) {
            this.typeElement.parentElement.classList.add('is-invalid');
            toast(__v('required', 'consultation_type')).error();
            this.focusedElement = this.typeElement;
            return false;
        }

        this.typeElement.parentElement.classList.remove('is-invalid');

        this.focusedElement = null;

        return true;
    }

    /**
     * Validate second step
     *
     * @returns {boolean}
     */
    secondStepIsValid(): boolean {
        if (! this.getPatientFirstname()) {
            this.firstnameElement.classList.add('is-invalid');
            toast(__v('required', 'firstname')).error();
            this.focusedElement = this.firstnameElement;
            return false;
        }

        this.firstnameElement.classList.remove('is-invalid');

        if (! this.getPatientLastname()) {
            this.lastnameElement.classList.add('is-invalid');
            toast(__v('required', 'lastname')).error();
            this.focusedElement = this.lastnameElement;
            return false;
        }

        this.lastnameElement.classList.remove('is-invalid');

        if (! this.mobileInstance.isValidNumber()) {
            this.mobileElement.classList.add('is-invalid');
            toast(__v('invalid.phone_number')).error();
            this.focusedElement = this.mobileElement;
            return false;
        }

        this.mobileElement.classList.remove('is-invalid');

        if (! [Gender.FEMALE, Gender.MALE].includes(this.getGender())) {
            this.genderElement.parentElement.classList.add('is-invalid');
            toast(__v('required', 'gender')).error();
            this.focusedElement = this.genderElement;
            return false;
        }

        this.genderElement.parentElement.classList.remove('is-invalid');

        // if the patient changed his mobile number, we need to send a new verification code
        // to the new mobile number, that's why we reset smsCounter to 0
        if (this.mobile !== this.mobileInstance.getNumber()) {
            this.mobile = this.mobileInstance.getNumber();
            this.smsCounter = 0; // I count on 'smsCounter' to know when to send the verification code
        }

        if (this.getPatientEmail() && ! isEmail(this.getPatientEmail())) {
            this.emailElement.classList.add('is-invalid');
            toast(__v('email', 'email')).error();
            this.focusedElement = this.emailElement;
            return false;
        }

        this.emailElement.classList.remove('is-invalid');

        if (! this.getPatientBirthdate()) {
            this.birthdateElement.classList.add('is-invalid');
            toast(__v('required', 'birthdate')).error();
            this.focusedElement = this.birthdateElement;
            return false;
        }

        this.birthdateElement.classList.remove('is-invalid');

        if (! this.termsElement.checked) {
            this.termsElement.classList.add('is-invalid');
            toast(__('accept_terms_and_conditions')).error();
            this.focusedElement = this.termsElement;
            return false;
        }

        this.termsElement.classList.remove('is-invalid');

        if (! this.privacyElement.checked) {
            this.privacyElement.classList.add('is-invalid');
            toast(__('accept_privacy_policy')).error();
            this.focusedElement = this.privacyElement;
            return false;
        }

        this.privacyElement.classList.remove('is-invalid');

        this.focusedElement = null;

        return true;
    }

    /**
     * Validate fourth step
     *
     * @returns {boolean}
     */
    fourthStepIsValid(): boolean {

        if (! this.getVerificationCode()) {
            this.verificationCodeElement.classList.add('is-invalid');
            toast(__v('required', 'verification_code')).error();
            this.focusedElement = this.verificationCodeElement;
            return false;
        }

        if (this.getVerificationCode().length < 4 || this.getVerificationCode().length > 4) {
            this.verificationCodeElement.classList.add('is-invalid');
            toast(__v('digits', {'attribute': 'verification_code', 'digits': 4})).error();
            this.focusedElement = this.verificationCodeElement;
            return false;
        }

        this.verificationCodeElement.classList.remove('is-invalid');

        this.focusedElement = null;

        return true;
    }

    /**
     * Navigate between steps
     *
     * @returns {Wizard}
     */
    navigate(): Wizard {
        if (this.currentStep > this.totalSteps) {
            console.log('You have reached the end of the wizard.');
            return;
        }

        document.querySelector(`#step-${this.currentStep}`).classList.remove('hidden');

        for (let i = 2; i <= this.totalSteps; i++) {
            if (i !== this.currentStep) {
                document.querySelector(`#step-${i}`).classList.add('hidden');
            }
        }

        return this;
    }

    /**
     * Increment current step
     *
     * @returns {Wizard}
     */
    incrementCurrentStep(): Wizard {
        this.currentStep++;
        return this;
    }

    /**
     * Descrement current step
     *
     * @returns {Wizard}
     */
    decrementCurrentStep(): Wizard {
        this.currentStep--;
        return this;
    }

    /**
     * Are we ready to book the appointment ?
     *
     * @returns {boolean}
     */
    readyToSubmit(): boolean {
        return this.currentStep === this.totalSteps;
    }

    /**
     * Submit the appointment
     *
     * @returns {void}
     */
    submitForm(): void {
        $.ajax({
            url: localizedRoute('frontend.instant_consult.store'),
            type: HttpMethod.POST,
            dataType: 'json',
            data: this.getData(),
            beforeSend: () => {
                this.showLoader();
                this.disableForwardButtons();
                this.disableBackwardButtons();
                this.disableResendVerificationCodeButton();
            }
        })
        .done((response) => {
            const appointmentRequest = AppointmentRequest.new(response as {});
            const _successSvg = successSvg();
            const message = currentLocaleIs('fr')
                ? `Merci d'avoir soumis votre demande de <strong>"Consultation Instantanée"</strong>. Nous envoyons actuellement votre demande à tous nos praticiens disponibles. Dès que nous trouverons un médecin disponible pour une consultation, un membre de notre équipe vous contactera pour finaliser votre rendez-vous. Nous vous remercions de votre patience.`
                : `شكرًا لك على تقديم طلب <strong>"الإستشارة الفورية"</strong>. نحن نقوم الآن بإرسال طلبك إلى جميع الأطباء المتوفرين لدينا. وبمجرد أن نجد طبيبًا متاحًا للإستشارة، سيتصل بك أحد أعضاء فريقنا لتأكيد الموعد. نشكرك على صبرك.`;
            const formArea    = document.querySelector('.formArea');
            formArea.innerHTML = '';
            formArea.innerHTML = `
                <div class="card-description mt-3">
                    <p class="text-center">${_successSvg}</p>
                    <p style="
                        text-align: justify;
                        line-height: 1.5rem;
                    ">${message}</p>
                    <a href="${localizedRoute('patient.profile.index')}" class="btn btn-primary btn-block">
                        ${isAuthenticated() ? __('access_profile') : __('complete_profile')}
                    </a>
                </div>
            `;
            setTimeout(() => {
                redirect(localizedRoute('patient.profile.index'));
            }, 1000 * 20);
        })
        .fail(failHandler())
        .always(() => {
            this.hideLoader();
            this.enableForwardButtons();
            this.enableBackwardButtons();
            this.enableResendVerificationCodeButton();
        });
    }

    /**
     * Form data
     *
     * @returns {object}
     */
    getData(): object {
        return {
            firstname        : this.getPatientFirstname(),
            lastname         : this.getPatientLastname(),
            gender           : this.getGender(),
            email            : this.getPatientEmail(),
            mobile           : this.getPatientMobile(),
            dial_code        : this.getPatientDialCode(),
            birthdate        : this.getPatientBirthdate(),
            terms            : this.termsElement.checked ? '1' : '0',
            privacy          : this.privacyElement.checked ? '1' : '0',
            verification_code: this.getVerificationCode(),
        };
    }

    /**
     * Get patient full name
     *
     * @returns {string}
     */
    getPatientFullName(): string {
        return `${ this.getPatientFirstname() } ${ this.getPatientLastname() }`;
    }

    /**
     * Get patient first name
     *
     * @returns {string}
     */
    getPatientFirstname(): string {
        return capitalize(this.firstnameElement.value.trim());
    }

    /**
     * Get patient last name
     *
     * @returns {string}
     */
    getPatientLastname(): string {
        return this.lastnameElement.value.trim().toUpperCase();
    }

    /**
     * Get patient mobile
     *
     * @returns {string}
     */
    getPatientMobile(): string {
        return this.mobileInstance.getNumber();
    }

    /**
     * Get patient dial code
     *
     * @returns {string}
     */
    getPatientDialCode(): string {
        return this.mobileInstance.getSelectedCountryData().dialCode;
    }

    /**
     * Get patient email
     *
     * @returns {string}
     */
    getPatientEmail(): string {
        return this.emailElement.value.trim();
    }

    /**
     * Get patient birthdate
     *
     * @returns {string}
     */
    getPatientBirthdate(): string {
        return this.birthdateElement.value.trim();
    }

    /**
     * Get verification code
     *
     * @returns {string}
     */
    getVerificationCode(): string {
        return this.verificationCodeElement.value.trim();
    }

    /**
     * Get selected motive name
     *
     * @returns {string}
     */
    getMotiveName(): string {
        return this.motiveElement.options[this.motiveElement.selectedIndex].text;
    }

    /**
     * Get selected motive id
     *
     * @returns {number}
     */
    getMotiveId(): number {
        return parseInt(this.motiveElement.value, 10);
    }

    /**
     * Get selected gender
     *
     * @returns {string}
     */
    getGender(): string {
        return this.genderElement.value;
    }

    /**
     * Get appointment type
     *
     * @returns {string}
     */
    getType(): string {
        return this.typeElement.value;
    }

    /**
     * Is former visitor ?
     *
     * @returns {boolean}
     */
    isFormerVisitor(): boolean {
        return this.isFormerVisitorElement.checked;
    }

    /**
     * Get medical information
     *
     * @returns {string}
     */
    getInfo(): string {
        return this.infoElement.value.trim();
    }

    /**
     * Get valid appointment types
     *
     * @returns {string[]}
     */
    validTypes(): string[] {
        return Object.values(AppointmentType);
    }

    /**
     * Send verification code when it's proper time
     */
    whenItsTimeSendVerificationCode(): void {
        if (this.itsTimeToSendVerificationCode()) {
            this.sendVerificationCode();
        }
    }

    /**
     * Send verification code
     *
     * @returns {void}
     */
    sendVerificationCode(): void {
        $.ajax({
            url: localizedRoute('frontend.verfication_code.send'),
            type: HttpMethod.POST,
            dataType: 'json',
            data: {
                phone_number: this.getPatientMobile()
            },
            beforeSend: () => {
                this.scrollToTop();
                this.showLoader();
                this.disableResendVerificationCodeButton();
            }
        })
        .done((response) => {
            toast(__('verification_code_sent_successfully')).success();
            this.smsCounter++;
        })
        .fail((fail) => {
            console.log('fail : ', fail);
        })
        .always(() => {
            this.hideLoader();
            setTimeout(() => {
                this.enableResendVerificationCodeButton();
            }, 10000);
        });
    }

    /**
     * Check if it's proper time to send verification code
     *
     * @returns {boolean}
     */
    itsTimeToSendVerificationCode(): boolean {
        return this.currentStep === 3 && this.smsCounter === 0;
    }

    /**
     * Enable 'forward' buttons
     *
     * @returns {void}
     */
    enableForwardButtons(): void {
        this.forwardButtons.forEach((button) => {
            button.removeAttribute('disabled');
        });
    }

    /**
     * Disable 'forward' buttons
     *
     * @returns {void}
     */
    disableForwardButtons(): void {
        this.forwardButtons.forEach((button) => {
            button.setAttribute('disabled', 'disabled');
        });
    }

    /**
     * Enable 'backward' buttons
     *
     * @returns {void}
     */
    enableBackwardButtons(): void {
        this.backwardButtons.forEach((button) => {
            button.removeAttribute('disabled');
        });
    }

    /**
     * Disable 'backward' buttons
     *
     * @returns {void}
     */
    disableBackwardButtons(): void {
        this.backwardButtons.forEach((button) => {
            button.setAttribute('disabled', 'disabled');
        });
    }

    /**
     * Enable 'resend verification code' button
     *
     * @returns {void}
     */
    enableResendVerificationCodeButton(): void {
        this.resendVerificationCodeButton.removeAttribute('disabled');
    }

    /**
     * Disable 'resend verification code' button
     *
     * @returns {void}
     */
    disableResendVerificationCodeButton(): void {
        this.resendVerificationCodeButton.setAttribute('disabled', 'disabled');
    }

    /**
     * Show loader
     *
     * @returns {void}
     */
    showLoader(): void {
        this.loaderElement.classList.remove('hidden');
    }

    /**
     * Hide loader
     *
     * @returns {void}
     */
    hideLoader(): void {
        this.loaderElement.classList.add('hidden');
    }

    /**
     * Scroll to top
     *
     * @returns {void}
     */
    scrollToTop(): void {
        const toElement = this.focusedElement
            ? this.focusedElement
            : document.querySelector('body');

        toElement.scrollIntoView({ behavior: 'smooth'});
    }
}

const wizard = new Wizard();

export default wizard;
